<template>
    <v-container id="simulateur">
        <v-card>
            <v-card-title class="title_display" @click="show.simulateur=!show.simulateur">
                <v-layout justify-space-between>
                    <h2>
                        Simulation
                    </h2>
                    <v-icon large right>
                        {{ show.simulateur ? 'arrow_drop_down' : 'arrow_left' }}
                    </v-icon>
                </v-layout>
            </v-card-title>
            <transition name="fade">
                <v-container v-if="show.simulateur" fluid>
                    <v-card style="margin-bottom: 1em;">
                        <table id="support">
                            <thead class="orange_cell">
                                <tr>
                                    <td v-for="header in headers" :key="header.value" :style="`width:${header.size}`">
                                        {{ header.text }}
                                    </td>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-if="supportsGuid.length > 0">
                                    <support-line v-for="guid in supportsGuid" :key="guid" :guid="guid" @update="update"/>
                                </template>
                                <template v-else>
                                    <tr>
                                        <td colspan="6" class="empty">
                                            Ajoutez des supports pour avoir une simulation de votre TLPE
                                        </td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                    </v-card>
                    <v-btn style="width: 100%;margin-bottom: 1em;height: 3em;" @click="add()">
                        Ajouter un support
                    </v-btn>
                    <v-card v-if="datas">
                        <table>
                            <tr class="orange_cell bottom_white_border">
                                <td style="width: 25%">
                                    &nbsp;
                                </td>
                                <td style="width: 25%">
                                    Nombre
                                </td>
                                <td style="width: 25%">
                                    Surface cumulée
                                </td>
                                <td style="width: 25%">
                                    Montant

                                </td>
                            </tr>
                            <tr>
                                <td class="orange_cell bottom_white_border">
                                    Enseignes
                                </td>
                                <td>
                                    {{ datas.enseignes.nombre }}
                                </td>
                                <td>
                                    {{ datas.enseignes.surface }} m²
                                </td>
                                <td>
                                    {{ datas.enseignes.montant }} €
                                </td>
                            </tr>
                            <tr>
                                <td class="orange_cell bottom_white_border">
                                    Pré-enseignes
                                </td>
                                <td>
                                    {{ datas.preenseignes.nombre }}
                                </td>
                                <td>
                                    {{ datas.preenseignes.surface }} m²
                                </td>
                                <td>
                                    {{ datas.preenseignes.montant }} €
                                </td>
                            </tr>
                            <tr>
                                <td class="orange_cell bottom_white_border">
                                    Publicité
                                </td>
                                <td>
                                    {{ datas.publicites.nombre }}
                                </td>
                                <td>
                                    {{ datas.publicites.surface }} m²
                                </td>
                                <td>
                                    {{ datas.publicites.montant }} €
                                </td>
                            </tr>
                            <tr>
                                <td class="orange_cell">
                                    Totaux
                                </td>
                                <td class="total">
                                    {{ datas.totaux.nombre}}
                                </td>
                                <td class="total">
                                    {{ datas.totaux.surface }} m²
                                </td>
                                <td class="total">
                                    {{ datas.totaux.montant }} €
                                </td>
                            </tr>
                        </table>
                        <p style="font-style: italic; margin-top: 1em;">
                            <v-icon>
                                warning
                            </v-icon>
                            La surface taxable de chaque support et leur montant sont arrondis au dixième le plus proche.
                        </p>
                    </v-card>
                </v-container>
            </transition>
        </v-card>
    </v-container>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex';
import SupportLine from './SupportLine.vue';
import { getUuid, getDatas } from '../../utils';

export default {
    name: 'SupportList',
    components: {
        'support-line': SupportLine,
    },
    mixins: [],
    props: {},
    data() {
        return {
            headers: [
                { text: 'Type', value: 'type', size: 20 },
                { text: 'Hauteur en mètres', value: 'hauteur', size: 10 },
                { text: 'Largeur en mètres', value: 'largeur', size: 10 },
                { text: 'Nombre de faces', value: 'faces', size: 10 },
                { text: 'Autre mesure', value: 'autre', size: 20 },
                { text: '', value: 'delete', size: 10 },
            ],
            datas: null,
        };
    },
    computed: {
        ...mapState('support', ['supports', 'supportsGuid']),
        ...mapState('type', ['types']),
        ...mapState('collectivite', ['tarifs', 'options', 'tarifsUsed']),
        ...mapState('show', ['show']),
        ...mapGetters('collectivite',['getCurrentTarifs','getCurrentOptions']),
    },
    watch: {},
    created() {
        this.update();
    },
    methods: {
        ...mapActions('support', ['addSupport']),
        ...mapMutations('collectivite', ['setTarifsUsed']),
        add() {
            this.addSupport({
                guid: getUuid(),
                type: null,
                hauteur: null,
                largeur: null,
                faces: 1,
                numerique: false,
                scelle: false,
            });
        },
        getNbTypes(type) {
            let nb = 0;
            this.supportsGuid.forEach((guid) => {
                if (this.supports[guid].type && this.supports[guid].type.code === type) {
                    nb++;
                }
            })

            return nb;
        },
        update() {
            this.datas = getDatas(this.supports, this.getCurrentTarifs, this.getCurrentOptions);
            this.setTarifsUsed(this.datas.tarifsUsed)
        },

    },
};
</script>

<style scoped>
.empty {
    background-color: #f4f4f4;
    text-align: center;
}

#support tr:nth-child(even), .total {
    background-color: #f4f4f4
}
</style>



// WEBPACK FOOTER //
// src/components/Simulateur/SupportList.vue